import { useEffect, useState } from 'react'
import { Path, UseFormReturn } from 'react-hook-form'
import { useDebounceValue } from 'usehooks-ts'

import { doesClientCodeExist } from '@/gen/publicApi'

import ExistenceCheckIcon, { ExistsState } from '@/components/existenceCheckIcon'
import FormInput from '@/components/form/formInput'

import { makeInputUppercaseAndRemoveNonAlphanumeric } from '@/utils/form'

interface Props<T extends { clientCode: string }> {
    form: UseFormReturn<T, any, undefined>
    onBlur: () => void
    onChange: (valid: boolean) => void
}

const ClientCodeInput = <T extends { clientCode: string }>({ form, onBlur, onChange }: Props<T>) => {
    const [debouncedValue, setValue] = useDebounceValue('', 500)
    const [exists, setExists] = useState<ExistsState>('pending')

    useEffect(() => {
        if (debouncedValue.length < 4 || debouncedValue.length > 8) {
            return
        }
        setExists('in_progress')
        doesClientCodeExist(debouncedValue)
            .then((res: any) => {
                // TODO - types? Why does `exists` not exist on `res?
                onChange(!res.exists)
                setExists(res.exists ? 'exists' : 'available')
            })
            .catch(() => {
                setExists('pending')
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedValue])

    return (
        <div className="flex space-x-4 pr-2">
            <FormInput
                className="flex-grow"
                control={form.control}
                name={'clientCode' as Path<T>}
                label={<>Client code</>}
                placeholder="ABC123"
                onBlur={onBlur}
                onInput={makeInputUppercaseAndRemoveNonAlphanumeric}
                autoComplete="off"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
            />
            <div className="mt-8 w-8 content-start">
                <ExistenceCheckIcon exists={exists} name="Client code" />
            </div>
        </div>
    )
}

export default ClientCodeInput
